import { Localized, useLocalization } from '@fluent/react';
import { useField } from 'formik';

import { InputFormik } from '#/components/controls/Input';
import { VehicleListboxFormik } from '#/components/controls/VehicleListbox';

const OfferForm: React.FC<OfferFormProps> = ({ name }) => {
  const { l10n } = useLocalization();
  const namePrefix = name ? `${name}.` : '';
  const [itemOfferedIdField] = useField(`${namePrefix}itemOfferedId`);

  return (
    <div className="space-y-2">
      <div className="grid md:grid-cols-12 gap-2 md:gap-4">
        <div className="md:col-span-9">
          <Localized id="offer-item-offered" attrs={{ placeholder: true }}>
            <VehicleListboxFormik
              additionalItems={[
                { bodyType: l10n.getString('other'), id: 'other', name: l10n.getString('other') },
              ]}
              name={`${namePrefix}itemOfferedId`}
            />
          </Localized>
        </div>

        <div className="md:col-span-3">
          <Localized id="offer-inventory-level" attrs={{ placeholder: true }}>
            <InputFormik type="number" max={99} min={1} name={`${namePrefix}inventoryLevel`} />
          </Localized>
        </div>
      </div>

      {itemOfferedIdField.value === 'other' && (
        <div>
          <Localized id="vehicle-name" attrs={{ placeholder: true }}>
            <InputFormik name={`$${namePrefix}vehicleName`} />
          </Localized>
        </div>
      )}
    </div>
  );
};
export type OfferFormProps = {
  name?: string;
};

export default OfferForm;
